<script>
export default {

    props: {
        className: {
            type: String,
            default: 'button button--outline'
        },
    },

    computed: {
        stored() {
            const { color, eContentLink, eContentLabel } = this.$store.getters
            return { color, eContentLink, eContentLabel }
        },
    },

    render(h) {
        const { stored, className } = this
        
        return h('router-link', {
            class: [
                className,
                className && `button--${stored.color}`,
            ],
            props: {
                tag: 'a',
                to: {
                    name: stored.eContentLink
                }
            }
        }, stored.eContentLabel)
    }
}
</script>